import { Link } from "react-router-dom";
import { imageUrl } from "../../utils/imageUrl";

const HomeEditorial = ({ section }) => {
  const settings = section?.settings || {};

  const kicker = settings.kicker || "Jooti Mood";
  const title = settings.title || section.title || "برای قدم‌هایی که قرار است راحت، شیک و دیده‌شده باشند";
  const subtitle =
    settings.subtitle ||
    "انتخابی از کفش‌ها و صندل‌هایی برای روزمره، کار، مهمانی و حرکت‌های ساده زندگی.";
  const primaryText = settings.primary_button_text || "کشف کالکشن‌ها";
  const primaryLink = settings.primary_button_link || "/products";
  const secondaryText = settings.secondary_button_text || "صندل‌های منتخب";
  const secondaryLink = settings.secondary_button_link || "/category/women-sandals";
  const image = settings.image || "";
  const theme = settings.theme || "dark";

  return (
    <section className={`home-dynamic-section about-store about-store-editorial about-store-editorial-${theme}`}>
      <div className="about-store-content">
        <span className="section-kicker">{kicker}</span>

        <h2>{title}</h2>

        <p>{subtitle}</p>

        <div className="about-store-actions">
          <Link to={primaryLink} className="btn btn-primary">
            {primaryText}
          </Link>

          <Link to={secondaryLink} className="btn btn-light">
            {secondaryText}
          </Link>
        </div>
      </div>

      <div className="about-store-panel">
        {image ? (
          <div className="about-store-image-panel">
            <img src={imageUrl(image)} alt={title} loading="lazy" />
          </div>
        ) : (
          <>
            <div>
              <strong>{settings.point_1_title || "Everyday"}</strong>
              <span>{settings.point_1_text || "برای استفاده روزمره، سبک و قابل اعتماد"}</span>
            </div>

            <div>
              <strong>{settings.point_2_title || "Minimal"}</strong>
              <span>{settings.point_2_text || "طراحی خلوت، زنانه و بدون شلوغی اضافه"}</span>
            </div>

            <div>
              <strong>{settings.point_3_title || "Selected"}</strong>
              <span>{settings.point_3_text || "مدل‌هایی که با دقت برای استایل واقعی انتخاب می‌شوند"}</span>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default HomeEditorial;
